module.exports = __webpack_public_path__ + "img/filter-job.a664574d.svg";